// extracted by mini-css-extract-plugin
module.exports = {"vGray16":"#9ea6b3","modalHeader":"Comments_modalHeader__2JSkd","modalTitle":"Comments_modalTitle__mNRtN","modalBody":"Comments_modalBody__2XrUX"};